import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getMethodHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "method", ...action.payload }),
		);
		yield put({
			type: types.GET_METHOD_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_METHOD_ERROR,
			payload,
		});
	}
}

export function* getMethodWatcherSaga() {
	yield takeLatest(types.GET_METHOD_START, getMethodHandlerSaga);
}

//create

// function* createMethodHandlerSaga(action) {
// 	//  //console.log("test",action.payload);
// 	const apiClient = apiClientFactory();
// 	try {
// 		const { data } = yield call(
// 			apiClient.post,
// 			endPoint.fromAddData("method"),
// 			action.payload.body,
// 		);
// 		yield put({
// 			type: types.CREATE_METHOD_SUCCESS,
// 			payload: data,
// 		});
// 	} catch (e) {
// 		const payload = e?.response?.data || e;
// 		yield put({
// 			type: types.CREATE_METHOD_ERROR,
// 			payload,
// 		});
// 	}
// }

// export function* createMethodWatcherSaga() {
// 	yield  takeLatest(types.CREATE_METHOD_START, createMethodHandlerSaga);
// }

//delete

function* deleteMethodHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("method", action.payload),
		);

		yield put({
			type: types.DELETE_METHOD_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_METHOD_ERROR,
			payload,
		});
	}
}

export function* deleteMethodWatcherSaga() {
	yield takeLatest(types.DELETE_METHOD_START, deleteMethodHandlerSaga);
}

//update

function* updateMethodHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.put,
			endPoint.dynamicUpdateItem({
				pageId: action.payload.pageId,
				dataId: action.payload.dataId,
			}),
			action.payload.body,
		);

		yield put({
			type: types.UPDATE_METHOD_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.UPDATE_METHOD_ERROR,
			payload,
		});
	}
}

export function* updateMethodWatcherSaga() {
	yield takeLatest(types.UPDATE_METHOD_START, updateMethodHandlerSaga);
}

//method form
function* updateMethodFormHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.put,
			endPoint.putmethodForm,
			action.payload.body,
		);

		yield put({
			type: types.METHOD_FORM_EDIT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.METHOD_FORM_EDIT_ERROR,
			payload,
		});
	}
}

export function* updateMethodFormWatcherSaga() {
	yield takeLatest(types.METHOD_FORM_EDIT_START, updateMethodFormHandlerSaga);
}

function* getMethodFormHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.getmethodForm(action.payload),
			action.payload.body,
		);

		yield put({
			type: types.METHOD_FORM_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.METHOD_FORM_ERROR,
			payload,
		});
	}
}

export function* getMethodFormWatcherSaga() {
	yield takeLatest(types.METHOD_FORM_START, getMethodFormHandlerSaga);
}
